import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalComputeDto } from "../dto/solar-proposal-compute.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The saved AI compute node with its estimated income, and the financing
 * lock. The gateway prices it from Vision's catalog; no provider call.
 */
export default function useSolarProposalCompute(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalComputeDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.compute(proposalId ?? ``),
    queryFn: () => solarProposalService.getCompute(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
